import { PAGE_NAMES as MYT_PAGE_NAMES } from 'tradera-apps/my-tradera/app/constants/page';

export const SURVEYS = {
    general: {
        survey: 'tradera/hur-tycker-du-att-det-fungerar-att-anvanda-tradera',
        supportURL: 'https://info.tradera.com/'
    },
    language: {
        survey: 'tradera/english-translation---rate-your-experience'
    },
    paynova: {
        survey: 'tradera/hur-tycker-du-att-paynova-fungerar',
        textKey: 'surveys_text_paynova'
    },
    cardVerification: {
        survey: 'tradera/vad-fick-dig-att-avbryta-kortverifieringen'
    },
    bankId: {
        survey: 'tradera/bankid'
    },
    [MYT_PAGE_NAMES.BuyerActiveItems]: {
        survey:
            'tradera/hur-tycker-du-det-fungerar-att-filtrera-soka-och-sortera-i-listan-for-aktiva-annonser'
    },
    [MYT_PAGE_NAMES.BuyerPurchases]: {
        survey:
            'tradera/hur-tycker-du-det-fungerar-att-filtrera-soka-och-sortera-i-listan-for-mina-kop'
    },
    [MYT_PAGE_NAMES.BuyerItemsLost]: {
        survey:
            'tradera/hur-tycker-du-det-fungerar-att-filtrera-soka-och-sortera-i-listan-for-mina-ej-vunna'
    },
    [MYT_PAGE_NAMES.SellerActive]: {
        survey:
            'tradera/hur-tycker-du-det-fungerar-att-filtrera-soka-och-sortera-i-listan-for-aktiva-annonser-2'
    },
    [MYT_PAGE_NAMES.SellerSold]: {
        survey:
            'tradera/hur-tycker-du-det-fungerar-att-filtrera-soka-och-sortera-i-listan-for-salda-annonser'
    },
    [MYT_PAGE_NAMES.SellerUnsold]: {
        survey:
            'tradera/hur-tycker-du-det-fungerar-att-filtrera-soka-och-sortera-i-listan-for-osalda-annonser'
    },
    valuationPage: {
        survey: 'tradera/vad-ar-den-vard-hur-tycker-varderingen-funkar-'
    },
    syiDraftPage: {
        survey: 'tradera/hur-fungerar-det-att-skapa-en-annons'
    },
    combinedShipping: {
        survey: 'tradera/samfrakt---som-sljare-hur-fungerar-det-fr-dig'
    },
    payouts: {
        survey: 'tradera/utbetalningar-hur-fungerar-den-for-dig'
    },
    translationImprovements: {
        survey: 'tradera/versattningar-forbattringsforslag'
    },
    shipping: {
        survey: 'tradera/fraktbokning---hur-fungerar-det-fr-dig'
    },
    selectShipping: {
        survey: 'tradera/hur-fungerar-det-att-valja-och-boka-frakt'
    }
};
